var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "eagle-tap", class: _vm.tapClass },
    [
      _c("h3", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.tapContext.title))
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "fit-for" }, [
        _vm._v(_vm._s(_vm.tapContext.subTitle))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "price" }, [
        _c("span", { staticClass: "symble" }, [_vm._v("¥")]),
        _vm._v(" "),
        _c("span", { staticClass: "money" }, [
          _vm._v(_vm._s(_vm.price.toFixed(2)))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "origin-price" }, [
        _vm._v(_vm._s(_vm.tapContext.originPrice))
      ]),
      _vm._v(" "),
      _c(
        "e-button",
        {
          attrs: { round: "", type: _vm.btType },
          on: { click: _vm.buyTapClicked }
        },
        [_vm._v(_vm._s(_vm.getConstants("EAGLE_LANDING_SALE_UPDATE")))]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "advantage" }, [
        _c("h3", { staticClass: "ad-title" }, [
          _vm._v(_vm._s(_vm.tapContext.edition))
        ]),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "ad-list" },
          [
            _c("li", [_vm._v(_vm._s(_vm.tapContext.saleText1))]),
            _vm._v(" "),
            _c("li", [_vm._v(_vm._s(_vm.tapContext.saleText2))]),
            _vm._v(" "),
            _c("Tips", {
              attrs: {
                text: _vm.tapContext.saleText3,
                content: _vm.tapContext.saleTip,
                color: _vm.color
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("h3", { staticClass: "ad-title" }, [
          _vm._v(
            "\n\t\t\t" +
              _vm._s(_vm.getConstants("EAGLE_LANDING_SALE_EAGLE_LICENSE")) +
              "\n\t\t"
          )
        ]),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "ad-list" },
          [
            _c("li", [
              _vm._v(_vm._s(_vm.getConstants("EAGLE_LANDING_SALE_EAGLE_TEXT1")))
            ]),
            _vm._v(" "),
            _c("Tips", {
              attrs: {
                text: _vm.getConstants("EAGLE_LANDING_SALE_EAGLE_TEXT2"),
                content: _vm.getConstants("EAGLE_LANDING_SALE_EAGLE_TIP"),
                color: _vm.color
              }
            })
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }